import { render, staticRenderFns } from "./TenderingRoute.vue?vue&type=template&id=03f69f22&"
import script from "./TenderingRoute.vue?vue&type=script&lang=js&"
export * from "./TenderingRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports